import { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Tab from './Tab';
import styles from './TabsLegacy.module.scss';

const cx = classNames.bind(styles);

const TabsLegacy = ({
  onChange = () => {},
  items = [],
  className = '',
  tabClassName = '',
  variant = 'underlined',
  activeIndex: initialActiveIndex = 0
}) => {
  const [activeIndex, setActiveIndex] = useState(initialActiveIndex);

  const handleClick = index => {
    setActiveIndex(index);
  };

  const tabsClassName = cx(styles.root, className);

  const tabs = items.map((tab, index) => (
    <Tab
      content={tab.label}
      id={index}
      onClick={handleClick}
      key={tab.id || index}
      active={activeIndex === index}
      onChange={onChange}
      variant={variant}
      className={tabClassName}
    />
  ));

  const activeTab = items[activeIndex];

  return (
    <div className={tabsClassName}>
      <div className={styles.items}>{tabs}</div>
      <div className={styles.content}>{activeTab?.render()}</div>
    </div>
  );
};

TabsLegacy.propTypes = {
  onChange: PropTypes.func,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      render: PropTypes.func
    })
  ),
  className: PropTypes.string,
  tabClassName: PropTypes.string,
  variant: PropTypes.string,
  activeIndex: PropTypes.number
};

export default TabsLegacy;
